/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigAssetLoaderService } from '../../../services/config-asset-loader.service';
import { LoginService } from '../../../services/login.service';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import { CommonFuntions } from '../../../common/common.function';

declare let $: any;

@Component({
  selector: 'app-imd-careteam-role',
  templateUrl: './imd-careteam-role.component.html',
  styleUrls: ['./imd-careteam-role.component.css']
})
export class ImdCareteamRoleComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: true })
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  token = 'Bearer ' + localStorage.getItem('token');
  valueToSearch: string;
  errorString: string;

  title: string;
  searchValue = ''
  userCount: number
  activeUsers: number
  inactiveUsers: number

  constructor(
    public router: Router,
    private loginService: LoginService
  ) {
    this.userCount = 0;
  }

  ngOnInit() {
    this.title = 'Doctor';

    const user = this.loginService.getCurrentUser();

    const optionObject = {
      ajax: {
        url: ConfigAssetLoaderService.getApiURL() + '/user/role/2?type=' + user.user_type.type + '&userid=' + user.user_id,
        dataSrc: function (json) {
          this.userCount = json.recordsTotal;
          this.activeUsers = json.activeCount || 0;
          this.inactiveUsers = json.inActiveCount || 0;
          return json.data;
        }.bind(this),
        type: 'POST',
        beforeSend: function (xhr) {
          if (!CommonFuntions.guardForAction(this.loginService, this.router)) {
            xhr.abort();
            return;
          }

          this.errorString = null;
          const token = localStorage.getItem('token');
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        }.bind(this),
        error: this.datatablesError.bind(this)
      },
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      lengthChange: false,
      searching: true,
      pageLength: 25,
      order: [[0, 'ASC']],
      info: false,
      stateSave: true,
      stateDuration: 5 * 20,
      rowCallback: (row: Node, data: any[] | Object, _index: number) => {
        // Unbind first in order to avoid duplicate handler
        $('td', row).unbind('click');
        $('td', row).bind('click', function () {
          this.viewUserInfo(data);
        }.bind(this));
      }
    };

    optionObject['columns'] = this.getColumn(user);

    this.dtOptions = optionObject;

    this.setSearchValueFromSavedState();

  }

  datatablesError(xhr, _error, _thrown) {
    const errorStatus = xhr.status;
    if (errorStatus == 401) {
      this.router.navigate(['/login']);
    }
    else if (errorStatus == 404) {
      this.errorString = 'Invalid Url';
    }
    else {
      this.errorString = 'Problem occurred. Please contact your administrator';
    }
  }

  search() {
    this.datatableElement.dtInstance.then(
      (dtInstance: DataTables.Api) => {
        dtInstance.search(this.valueToSearch).draw();
      }
    );
  }

  searchString(searchValue: string) {
    this.valueToSearch = searchValue;
    this.search();
  }

  viewUserInfo(info: any) {
    // if(this.user)
    this.router.navigate(['/profile', info.user_id]);
  }

  private getColumn(user: any) {
    let columns;
    if (user.user_type.type.toLowerCase() === 'admin' || user.user_type.type.toLowerCase() === 'cmmanager' ||
      user.user_type.type.toLowerCase() === 'careteam') {
      columns = [
        {
          title: 'Name',
          render: function (_data, _type, row, _meta) {
            const fullName = $.fn.dataTable.render.text().display(row.full_name);
            if (row.is_all_partners) {
              if (row.is_all_partners == 1) {
                return `<div>${fullName} <span class="badge-small badge-secondary" title="All Clients">All</span></div>`;
              }
              else if (row.is_all_partners == 2) {
                return `<div>${fullName} <span class="badge-small badge-yellow" title="All Ally Clients">Ally</span></div>`;
              }
              else if (row.is_all_partners == 3) {
                return `<div>${fullName} <span class="badge-small badge-orange" title="All Non-ally Clients">Cloud</span></div>`;
              }
            }
            else {
              return `<div>${fullName}</div>`;
            }
          }
        },
        {
          title: 'Company',
          render: function (_data, _type, row, _meta) {

            if (!row.user_partners || row.user_partners.length < 1) {
              return '';
            }

            let partnerList = '';
            const partnerListArray = [];
            let hasMorePartner = false;
            row.user_partners.forEach(partner => {
              if (partnerListArray.length < 5) {
                partnerList = partnerList + '<li>' + $.fn.dataTable.render.text().display(partner?.partner?.partner_name) + '</li>';
              }
              else if (!hasMorePartner) {
                hasMorePartner = true;
              }
              if (partner?.partner && !partnerListArray.includes(partner?.partner?.partner_name)) { partnerListArray.push(partner?.partner?.partner_name); }
            });

            if (hasMorePartner) { partnerList = partnerList + '<span class="text text--dark-grey">More ...</span>'; }
            if (row.is_all_partners) {
              if (row.is_all_partners == 1) {
                return '<div style="width: 150px">All Clients</div>';
              }
              else if (row.is_all_partners == 2) {
                return '<div style="width: 150px">All Ally Clients</div>';
              }
              else if (row.is_all_partners == 3) {
                return '<div style="width: 150px">All Non-Ally Clients</div>';
              }
            }
            return '<div style="width: 150px" title="' + $.fn.dataTable.render.text().display(partnerListArray.join(String.fromCharCode(13)).toString()) + '">' + row.user_partners.length + ' Clients</div>';
          }
        },
        {
          title: 'Phone Number',
          render: function (_data, _type, row, _meta) {
            if (!row.phone_number || row.phone_number === '') {
              return '';
            }

            return $.fn.dataTable.render.text().display(row.phone_number);
          }
        },
        {
          title: 'Email',
          render: function (_data, _type, row, _meta) {
            return $.fn.dataTable.render.text().display(row.email);
          }
        },
        {
          title: 'Status',
          render: function (_data, _type, row, _meta) {
            if (row.is_deleted) {
              return 'Inactive';
            }
            else {
              return 'Active';
            }
          },
          orderable: false
        }
      ];
    }

    return columns;
  }

  setSearchValueFromSavedState() {

    const state = localStorage.getItem('DataTables_imd_careteams_/imd-careteam-role');

    if (state == null) {
      this.searchValue = '';
      return;
    }

    const searchValue = JSON.parse(state).search['search'];

    if (searchValue != null) {

      this.searchValue = searchValue;

    }
  }
}
